export default ({
  "terms": {
    "electronicSignature": "Billy Joel",
    "agreedToTerms": true,
  },
  "software": {
  },
  "billingAddress": {
    "companyName": "Billy Joel",
    "state": "NY",
    "address1": "99 Cooking Ave",
    "city": "Hollywood",
    "zip": "90210",
    "country": "CA",
    "phone": "555-555-1234"
  },
  "shippingAddress": {
    "companyName": "Billy Joel",
    "state": "NY",
    "address1": "99 Cooking Ave",
    "city": "Hollywood",
    "zip": "90210",
    "country": "CA",
    "phone": "555-555-1234"
  },
  "contact": {
    "firstName": "Billy",
    "lastName": "Joel",
    "phone": "555-555-1234",
    "email": "Billy@example.com",
    "jobTitle": "Talk Show Host"
  },
  "forteResponse": {
    "event": "success",
    "customer_token": "KwiOo49I5ES3e-kG2iOByA",
    "paymethod_token": "NFY2BFdDikeTXoSlGyNCPg",
    "method": "token",
    "request_id": "3dceae7c-cbec-49ab-aa93-64b8900feb6c",
    "version_number": "1.0",
    "last_4": "1111",
    "method_used": "visa",
    "hash_method": "md5",
    "expire_month": "02",
    "expire_year": "2022",
    "signature": "3600df22be3c4f21bb7fbd8bd0a9c9cc",
    "utc_time": "636854515141448976"
  },
  "orders": [
    {
      "id": 1,
      "tradeCode": "HVC",
      "market": "Commercial",
      "printedName": "Billy Joel",
      "pricingFormat": "Agreement Reg-OT",
      "partsTaxCalculation": "",
      "partsMarkupOption": "Option 2",
      "partsMarkupTable": "",
      "regularFlatAdd": "2.00",
      "overtimeFlatAdd": "2.00",
      "regularLaborRate": "",
      "overtimeLaborRate": "",
      "regularDiscountAmount": "",
      "regularDiscountType": "%",
      "overtimeDiscountAmount": "",
      "overtimeDiscountType": "%",
      "laborTaxRate": "",
      "partsTaxRate": "",
      "numberOfPrintedBooks": 0,
      "numberOfLicenses": 1,
      "bookSelected" : false,
      "displayBarcodes": false,
      "roundedPrices": true,
      "displayTime": true,
      "oems": [],
      "printedGroupCodes": {},
      "specialRequests": "",
      "column1Highlighted": false,
      "column2Highlighted": false,
      "column3Highlighted": false,
      "column4Highlighted": false,
      "column1Printed": true,
      "column2Printed": true,
      "column3Printed": true,
      "column4Printed": true,
      "column1Title": "Repair\nFee",
      "column2Title": "After\nHours",
      "column3Title": "Service\nAgreement",
      "column4Title": "Agreement\nSavings",
      "title": "HVAC Commercial",
      "tradeName": "HVAC Commercial",
      "isComplete": false
    },
    {
      "id": 2,
      "tradeCode": "HVC",
      "market": "Residential",
      "printedName": "Billy Joel",
      "pricingFormat": "Agreement Reg-OT",
      "partsTaxCalculation": "",
      "partsMarkupOption": "Option 2",
      "partsMarkupTable": "",
      "regularFlatAdd": "2.00",
      "overtimeFlatAdd": "2.00",
      "regularLaborRate": "",
      "overtimeLaborRate": "",
      "regularDiscountAmount": "",
      "regularDiscountType": "%",
      "overtimeDiscountAmount": "",
      "overtimeDiscountType": "%",
      "laborTaxRate": "",
      "partsTaxRate": "",
      "numberOfPrintedBooks": 0,
      "numberOfLicenses": 1,
      "bookSelected" : false,
      "displayBarcodes": false,
      "roundedPrices": true,
      "displayTime": true,
      "oems": [],
      "printedGroupCodes": {},
      "specialRequests": "",
      "column1Highlighted": false,
      "column2Highlighted": false,
      "column3Highlighted": false,
      "column4Highlighted": false,
      "column1Printed": true,
      "column2Printed": true,
      "column3Printed": true,
      "column4Printed": true,
      "column1Title": "Repair\nFee",
      "column2Title": "After\nHours",
      "column3Title": "Service\nAgreement",
      "column4Title": "Agreement\nSavings",
      "title": "HVAC Residential",
      "tradeName": "HVAC Residential",
      "isComplete": false
    },
    {
      "id": 3,
      "tradeCode": "PLB",
      "market": "Residential",
      "printedName": "Billy Joel",
      "pricingFormat": "Agreement Reg-OT",
      "partsTaxCalculation": "",
      "partsMarkupOption": "Option 2",
      "partsMarkupTable": "",
      "regularFlatAdd": "2.00",
      "overtimeFlatAdd": "2.00",
      "regularLaborRate": "",
      "overtimeLaborRate": "",
      "regularDiscountAmount": "",
      "regularDiscountType": "%",
      "overtimeDiscountAmount": "",
      "overtimeDiscountType": "%",
      "laborTaxRate": "",
      "partsTaxRate": "",
      "numberOfPrintedBooks": 0,
      "numberOfLicenses": 1,
      "bookSelected" : false,
      "displayBarcodes": false,
      "roundedPrices": true,
      "displayTime": true,
      "oems": [],
      "printedGroupCodes": {},
      "specialRequests": "",
      "column1Highlighted": false,
      "column2Highlighted": false,
      "column3Highlighted": false,
      "column4Highlighted": false,
      "column1Printed": true,
      "column2Printed": true,
      "column3Printed": true,
      "column4Printed": true,
      "column1Title": "Repair\nFee",
      "column2Title": "After\nHours",
      "column3Title": "Service\nAgreement",
      "column4Title": "Agreement\nSavings",
      "title": "Plumbing",
      "tradeName": "Plumbing",
      "isComplete": false
    },
    {
      "id": 4,
      "tradeCode": "ELE",
      "market": "Residential",
      "printedName": "Billy Joel",
      "pricingFormat": "Agreement Reg-OT",
      "partsTaxCalculation": "Tax Sale",
      "partsMarkupOption": "Option 2",
      "partsMarkupTable": "",
      "regularFlatAdd": "2.00",
      "overtimeFlatAdd": "2.00",
      "regularLaborRate": "110",
      "overtimeLaborRate": "125",
      "regularDiscountAmount": "15",
      "regularDiscountType": "%",
      "overtimeDiscountAmount": "10",
      "overtimeDiscountType": "%",
      "laborTaxRate": "8",
      "partsTaxRate": "8",
      "numberOfPrintedBooks": 0,
      "numberOfLicenses": 1,
      "bookSelected" : true,
      "displayBarcodes": false,
      "roundedPrices": true,
      "displayTime": true,
      "oems": [],
      "printedGroupCodes": {},
      "specialRequests": "",
      "column1Highlighted": false,
      "column2Highlighted": false,
      "column3Highlighted": false,
      "column4Highlighted": false,
      "column1Printed": true,
      "column2Printed": true,
      "column3Printed": true,
      "column4Printed": true,
      "column1Title": "Repair\nFee",
      "column2Title": "After\nHours",
      "column3Title": "Service\nAgreement",
      "column4Title": "Agreement\nSavings",
      "title": "Electrical",
      "tradeName": "Electrical",
      "isComplete": false,
    }
  ],
  "useBillingAddress": true
})